module.exports = __webpack_public_path__ + "assets/icon_syringe.39761792.svg";